import { useFeatureFlags } from '@kaiizen/kai-pro-api-react-state';

import { RedesignedDashboardPage } from './Dashboard/RedesignedDashboardPage';
import { TurnBasedDashboardPage } from './Dashboard/TurnBasedDashboardPage';

/** Selects the turn-based dashboard only for organizations enrolled in its workflow. */
export const DashboardPage = () => {
  const { featureFlags } = useFeatureFlags();

  return featureFlags.turnBasedHandoff
    ? <TurnBasedDashboardPage />
    : <RedesignedDashboardPage />;
};
